import { useTheme } from "@/hooks/useTheme";
import { Moon, Sun } from "lucide-react";
import { useTranslation } from "react-i18next";
import * as styles from "./ThemeToggle.styles";

const ThemeToggle = () => {
  const { t } = useTranslation("components");
  const { theme, toggle } = useTheme();

  return (
    <button
      onClick={toggle}
      className={styles.button}
      aria-label={theme === "light" ? t("switchToDark") : t("switchToLight")}
      title={theme === "light" ? t("switchToDark") : t("switchToLight")}
    >
      {theme === "light" ? <Moon className={styles.iconH4_5W4_5} /> : <Sun className={styles.iconH4_5W4_5} />}
    </button>
  );
};

export default ThemeToggle;
